import {createContext} from 'react'
import {SnackbarHandler} from 'types/components'

export const SnackbarContext = createContext<SnackbarHandler | undefined>(
  undefined,
)
